import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector} from 'react-redux';

import T, { Translate } from '../../i18n/i18n';
import { HeaderRow, ButtonBack, Title, ButtonIcon, Input, Select, Button, FriendsPage, FriendItem, FriendLetter, FriendData, FriendName, FriendUsername, FriendCommonTable, FriendInvited, FriendRequest, FriendRequestLabel, FriendRequestButtons, NoFriends, MessageOk, FriendsWrapper, NoUsername } from './Friends.styles';
import { getFriendsListPage, getProfileFind, acceptFriendRequest, cancelFriendRequest, getBlockedUsers } from '../../../services/friends';
import { profilesActions, rtcBufferActions } from '../../../redux/actions';

export default () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const lastUpdateFriendList = useSelector(state => state.profilesState.updateFriendlist);
    const filter = useSelector(state => state.profilesState.filter);
    const isFiltering = useSelector(state => state.profilesState.isFiltering);
    const profiles = useSelector(state => state.profilesState.profiles);
    const profType = useSelector(state => state.profilesState.profType);
    const friends = useSelector(state => state.profilesState.friends);
    const pending = useSelector(state => state.profilesState.pending);
    const invited = useSelector(state => state.profilesState.invited);
    const message = useSelector(state => state.profilesState.message);
    const messageType = useSelector(state => state.profilesState.messageType);
    const messageTime = useSelector(state => state.profilesState.messageTime);

    const [showExtraActions, setShowExtraActions] = useState(false);
    
    const handleGetData = (page) => {
        let setState = true;

        (async () => {
            let data = await getFriendsListPage(page);

            if (setState) {
                dispatch(profilesActions.loadFriends(
                    data.payload.friends ?? [],
                    data.payload.invited ?? [],
                    data.payload.pending ?? [],
                ));
            }
        })();

        return () => {setState = false;}
    };

    const handleRefresh = (page) => {
        handleGetData(page);
        dispatch(profilesActions.setMessage("",""));
        dispatch(profilesActions.setFilter("", false));
        dispatch(profilesActions.loadProfiles([]));

        
    };

    const handleOpenExtra = () => {
        setShowExtraActions(true)
    };

    const handleCloseExtra = () => {
        dispatch(profilesActions.setProfilesType());
        setShowExtraActions(false);
    }

    const handleViewBlocked = async () => {
        let res = await getBlockedUsers();
        console.log(res);
        if (res.status === 'ok') {
            dispatch(profilesActions.loadProfiles(res.payload,"blocked"));
        }
    }

    const handleChangeFilter = (e) => {
        let value = e.target.value;
        dispatch(profilesActions.setFilter(value, isFiltering));
    }

    const handleSearch = async () => {
        if (!filter) {
            dispatch(profilesActions.setFilter("", false));
            return;
        }

        dispatch(profilesActions.setFilter(filter, true));
        
        let profiles = await getProfileFind(filter);
        if (profiles.status === 'ok') {
            dispatch(profilesActions.loadProfiles(profiles.payload));
        }
    };

    const handleAcceptRequest = async (e, id, email) => {
        e.stopPropagation();
        e.preventDefault();

        let res = await acceptFriendRequest(id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate("friends.accepted"),"ok"));
            /*dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));*/
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: email,
                data: JSON.stringify({friend:id, user: userId})
            }));
            dispatch(profilesActions.setUpdateFriendlist());
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
    };

    const handleRejectRequest = async (e, id) => {
        e.stopPropagation();
        e.preventDefault();

        let res = await cancelFriendRequest(id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate("friends.removed"),"ok"));
            dispatch(profilesActions.loadFriends(
                res.payload.friends ?? [],
                res.payload.invited ?? [],
                res.payload.pending ?? [],
            ));
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
        }
    };

    const handleOpenProfile = (id) => {
        dispatch(profilesActions.setMessage("",""));
        history.push(`/home/user/${id}`)
    };
    
    const handleKeypress = (e) => {
        if (e.which === 13) {
            handleSearch();
        }
    };

    const handleBack = () => {
        dispatch(profilesActions.setMessage("",""));
        history.goBack();
    };

    const renderFriend = (profileType, item) => {
        const relationType = profileType !== "filter" ? profileType : ("filter"+item.relation)
        return <FriendItem key={item.id} className={relationType} onClick={()=>{handleOpenProfile(item.id)}}>
            <FriendLetter bgColor={item.color} fgColor={item.fgColor}>{String(item.name).substring(0,1).toUpperCase()}</FriendLetter>
            <FriendData>
                <FriendName>{item.name}</FriendName>
                <FriendUsername>{item.username ? `@${item.username}` : <NoUsername><T value="friends.nousername" /></NoUsername>}</FriendUsername>
                {relationType === 'friend' || relationType === 'filter3' ?
                    <FriendCommonTable>{item.tables} <T value="friends.commonTables" /></FriendCommonTable>
                : null}
                {relationType === 'invited' || relationType === 'filter2' ?
                    <FriendInvited><T value="friends.invited" /></FriendInvited>
                : null}
                {relationType === 'unknown' || relationType === 'filter0' ?
                    <FriendInvited><T value="friends.unknown" /></FriendInvited>
                : null}
                {relationType === 'blocked' ?
                    <FriendInvited><T value="friends.blocked" /></FriendInvited>
                : null}
                {relationType === 'pending' || relationType === 'filter1' ?
                    <FriendRequest>
                        <FriendRequestLabel><T value="friends.accept" /></FriendRequestLabel>
                        <FriendRequestButtons>
                            <ButtonIcon className="yes" color="#0c0" onClick={(e)=>{handleAcceptRequest(e, item.id, item.email)}} icon="\F012C" title={Translate("yes")} />
                            <ButtonIcon className="no" color="#f33" onClick={(e)=>{handleRejectRequest(e, item.id)}} icon="\F0156" title={Translate("no")} />
                        </FriendRequestButtons>
                    </FriendRequest>
                : null}
            </FriendData>
        </FriendItem>
    }

    useEffect(()=>{
        if (messageTime < (new Date).getTime() - 30000) {
            dispatch(profilesActions.setMessage("",""));
        }

        if (!lastUpdateFriendList) {
            return;
        }

        let fn = handleGetData(1);
        return ()=>{fn()};
    }, [lastUpdateFriendList]);

    return <>
        <HeaderRow>
            <ButtonBack color="#aaa" onClick={handleBack} />
            <Title><T value="tables.titleFriends" /></Title>
            {showExtraActions ? <>
                <Button color="#f33" onClick={handleViewBlocked}><T value="friends.viewblocked" /></Button>
                <Button color="#888" onClick={handleCloseExtra}><T value="back" /></Button>
            </> : <>
                <Input onChange={handleChangeFilter} onKeyPress={handleKeypress} value={filter} placeholder={Translate("tables.searchplaceholder")} />
                <Button color="#26f" onClick={handleSearch}><T value="tables.searchbtn" /></Button>
                <ButtonIcon color="#f92" onClick={handleRefresh} icon="\F0450" title={Translate("tables.refreshFriends")} />
                <ButtonIcon color="#be5cde" onClick={handleOpenExtra} icon="\F01D8" title={Translate("tables.more")} />
            </>}
        </HeaderRow>
        {messageType === 'ok' ? <MessageOk>{message}</MessageOk> : null}
        <FriendsWrapper>
            {profType === 'blocked' ? <>
                {!profiles || profiles.length === 0 ? <NoFriends className="noBlocked"><T value="friends.noBlocked" /></NoFriends> : null }
            </> : <>
                {isFiltering ? <>
                    {!profiles || profiles.length === 0 ? <NoFriends className="noProfiles"><T value="friends.noProfiles" /></NoFriends> : null }
                </> : <>
                    {!pending || !friends || !invited || (pending.length === 0 && friends.length === 0 && invited.length === 0) ? <NoFriends><T value="friends.noFriends" /></NoFriends> : null }
                </> }
            </>}
            <FriendsPage>
                {profType === 'blocked' ? <>
                    {profiles && profiles.length ? profiles.map(f => renderFriend('blocked', f)) : null}
                </> : <>
                    {isFiltering ? <>
                        {profiles && profiles.length ? profiles.map(f => renderFriend('filter', f)) : null}
                    </> : <>
                        {pending && pending.length ? pending.map(f => renderFriend('pending', f)) : null}
                        {friends && friends.length ? friends.map(f => renderFriend('friend', f)) : null}
                        {invited && invited.length ? invited.map(f => renderFriend('invited', f)) : null}
                    </> }
                </>}
            </FriendsPage>
        </FriendsWrapper>
    </>
};